import { Component, OnInit } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { AuthService } from "../../service/auth.service";
import { LoaderService, Message } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styles: [],
  standalone: false,
})
export class UserComponent implements OnInit {
  constructor(
    private transloco: TranslocoService,
    private auth: AuthService,
    private message: Message,
    private loader: LoaderService
  ) {}
  darkMode = false;
  invertColors = localStorage.getItem("isInverted") == "true";
  currentContrast = localStorage.getItem("colorAccessibility")
    ? parseInt(localStorage.getItem("colorAccessibility") ?? "100")
    : 100;
  currentLanguage = { value: "it", label: "Italiano" };
  currentZoom = { value: 1, label: "100%" };
  languages = [
    { value: "it", label: "Italiano" },
    { value: "en", label: "English" },
  ];
  dataPassword = {
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
  };
  showModalChangePassword = false;
  userInfo: any = {};
  zoomAvailable = [
    { value: 0.25, label: "25%" },
    { value: 0.5, label: "50%" },
    { value: 0.75, label: "75%" },
    { value: 1, label: "100%" },
    { value: 1.25, label: "125%" },
    { value: 1.5, label: "150%" },
    { value: 1.75, label: "175%" },
    { value: 2, label: "200%" },
  ];

  ngOnInit(): void {
    let accessibility = localStorage.getItem("accessibility");
    if (accessibility) {
      this.currentZoom = JSON.parse(accessibility);
    }
    let language = localStorage.getItem("language");
    if (language) {
      this.currentLanguage = JSON.parse(language);
    }
    this.darkMode = localStorage.getItem("theme") === "dark" ? true : false;
    4;
    this.getMe();
  }

  getMe() {
    this.auth.getMe().subscribe({
      next: (value: any) => {
        this.userInfo = value;
      },
    });
  }

  changeColors(event?: any) {
    let body = document.getElementById("body");

    if (body) {
      if (event) {
        body.style.filter = `contrast(${event?.value}%)`;
        localStorage.setItem("colorAccessibility", event.value);
      } else {
        body.style.filter = `contrast(${localStorage.getItem(
          "colorAccessibility"
        )}%)`;
      }
    }
  }

  invert(event: any) {
    this.invertColors = event;
    let containerBody = document.getElementById("container-body");
    if (containerBody) {
      containerBody.style.filter = `${event ? "invert(100%)" : "invert(0)"}`;
      localStorage.setItem("isInverted", event);
    }
  }

  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("roleId");
    window.location.replace("login");
  }

  changeTheme() {
    if (localStorage.getItem("theme") !== "dark") {
      localStorage.setItem("theme", "dark");
    } else {
      localStorage.setItem("theme", "base");
    }
    this.darkMode = localStorage.getItem("theme") === "dark" ? true : false;
    this.getTheme();
  }

  changeLanguage(language: any) {
    localStorage.setItem("language", JSON.stringify(language));
    this.transloco.setActiveLang(language.value);
  }

  changeZoom(item: any) {
    localStorage.setItem("accessibility", JSON.stringify(item));
    this.getAccessibility();
  }

  getAccessibility() {
    let accessibility: any = localStorage.getItem("accessibility");
    if (accessibility) {
      accessibility = JSON.parse(accessibility);
      document.body.style.setProperty(
        "--small",
        12 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--normal",
        14 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--medium",
        16 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--large",
        18 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--title",
        24 * accessibility?.value + "px"
      );
    }
  }
  getTheme() {
    let theme = localStorage.getItem("theme");
    switch (theme) {
      case "base":
        document.body.style.setProperty("--primary", "#47AD9F");
        document.body.style.setProperty("--secondary", "#102A35");
        document.body.style.setProperty("--tertiary", "#FFFFFF");
        document.body.style.setProperty("--quaternary", "#111111");
        break;
      case "dark":
        document.body.style.setProperty("--primary", "#102A35");
        document.body.style.setProperty("--secondary", "#47AD9F");
        document.body.style.setProperty("--tertiary", "#111111");
        document.body.style.setProperty("--quaternary", "#FFFFFF");
        break;
      default:
        document.body.style.setProperty("--primary", "#47AD9F");
        document.body.style.setProperty("--secondary", "#102A35");
        document.body.style.setProperty("--tertiary", "#FFFFFF");
        document.body.style.setProperty("--quaternary", "#111111");

        break;
    }
  }

  changePassword() {
    if (
      this.dataPassword.oldPassword &&
      this.dataPassword.newPassword &&
      this.dataPassword.newPasswordConfirm
    ) {
      if (
        this.dataPassword.newPassword === this.dataPassword.newPasswordConfirm
      ) {
        this.loader.on();
        this.auth.changePassword(this.dataPassword).subscribe({
          next: (value) => {
            this.loader.off(true);
            this.showModalChangePassword = false;
            this.message.showMessage("Password cambiata", "success");
            this.dataPassword = {
              oldPassword: "",
              newPassword: "",
              newPasswordConfirm: "",
            };
          },
          error: (value) => {
            this.loader.off(true);
            this.showModalChangePassword = false;
            this.message.showMessage(value.error.message, "error");
            this.dataPassword = {
              oldPassword: "",
              newPassword: "",
              newPasswordConfirm: "",
            };
          },
        });
      } else {
        this.message.showMessage(
          "Conferma password e nuova password devono essere uguali",
          "error"
        );
      }
    } else {
      this.message.showMessage("Compila tutti i campi correttamente", "error");
    }
  }
}
